// purpose
// Get current step
// Find next step
// Find previous step
// Navigate

//  * Responsibilities:
//  * - Navigate to next workflow step
//  * - Navigate to previous workflow step
//  * - Keep workflow state synchronized




/**
 * Purpose:
 * Provides workflow-aware navigation.
 *
 * Why:
 * Screens should not contain route navigation logic.
 *
 * Responsibilities:
 * - Navigate to next workflow step
 * - Navigate to previous workflow step
 *
 * Does NOT:
 * - Build workflows
 * - Validate forms
 * - Call APIs
 */


import { useNavigate } from "react-router-dom";
import { FlowEngine } from "../sendWorkflow/engine/flowEngine";
import { useWorkflowStore } from "../store/sendmoneyWorkflowStore";
import { SEND_MONEY_ROUTES } from "../routes/sendMoneyRoutes";

export function useWorkflowNavigation() {
  const navigate = useNavigate();
  const setCurrentStep = useWorkflowStore(
      state => state.setCurrentStepKey
    );
  const setIsEditMode = useWorkflowStore(
    (state) => state.setIsEditMode
  );

  const goNext = () => {
    const { activeWorkflow, currentStepKey, isEditMode } =
      useWorkflowStore.getState();
    if (!currentStepKey) {
      return;
    }

    const currentStep = activeWorkflow.find(
      (step) => step.key === currentStepKey
    );

    if (isEditMode && currentStep?.editBehavior === "RETURN_TO_REVIEW") {
      setIsEditMode(false);
      setCurrentStep("FINAL_REVIEW");
      navigate(SEND_MONEY_ROUTES.FINAL_REVIEW);
      return;
    }

    const engine = new FlowEngine(activeWorkflow);
    const nextStep = engine.getNextStep(currentStepKey);

    console.log("activeWorkflow", activeWorkflow);
    console.log("nextStep", nextStep);
    console.log("currentStepKey", currentStepKey);
    
    if (!nextStep) {
      return;
    }
    setCurrentStep(nextStep.key);
    navigate(nextStep.route);
  };

  const goBack = () => {
    const { activeWorkflow, currentStepKey } =
      useWorkflowStore.getState();

    if (!currentStepKey) {
      return;
    }

    const engine =
      new FlowEngine(activeWorkflow);

    const previousStep =
      engine.getPreviousStep(currentStepKey);

    if (!previousStep) {
      return;
    }

    setCurrentStep(previousStep.key);

    navigate(previousStep.route);
  };

  return {
    goNext,
    goBack,
  };
}
